import { useDispatch, useSelector } from "react-redux";
import PageContainer from "../components/PageContainer";
import PageTitle from "../components/PageTitle";
import { GreenButton } from "../components/buttons";
import { useEffect, useState } from "react";
import { getAdminActivities, setIsNeedRefresh } from "../redux/adminActivitiesSlice";
import AdminPanel from "../components/AdminPanel";
import AdminActivityFilter from "../components/AdminActivitiesFilter";
import Loader from "../components/Loader";
import Error from "../components/Error";
import ActivitiesNameSearch from "../components/ActivitiesNameSearch";
import AdminCard from "../components/AdminCard";
import { setBacklink } from "../redux/backlinkSlice";

const HandleActivities = () => {
    const { isLoading, error, count, data, isNeedRefresh } = useSelector(state => state.adminActivities);
    const dispatch = useDispatch();

    // Eseguo la chiamata iniziale a admin-activities
    useEffect(() => {
        if (!data) {
            dispatch(getAdminActivities({ selectionKey: '', selectionValue: '', sortBy: '', reverse: '', page: '', pageSize: '' }))
        }
    }, [data])

    // Questo useEffect controlla il ritorno alla pagina nel caso data sia già memorizzato in Redux (quindi non cambia)
    // Imposta anche il backlink su "/"
    useEffect(() => {
        if (data) {
            dispatch(getAdminActivities({ selectionKey: '', selectionValue: '', sortBy: '', reverse: '', page: '', pageSize: '' }))
        }
        dispatch(setBacklink("/"))
    }, [])

    // Rifaccio la chiamata slice se needRefresh viene settato
    useEffect(() => {
        if (isNeedRefresh) {
            dispatch(getAdminActivities({ selectionKey: '', selectionValue: '', sortBy: '', reverse: '', page: '', pageSize: '' }));
            dispatch(setIsNeedRefresh(false));
        }
    }, [isNeedRefresh])

    // Gestisco la ricerca per nome
    const [searchInput, setSearchInput] = useState('');
    const handleSearchInput = (event) => {
        const { value } = event.target;
        setSearchInput(value);
    }

    return (
        <PageContainer px="4" desktopItems="center">
            <PageTitle title="Gestione attività" backLink="/" />

            <div className="SPLITPAGE flex flex-col md:flex-row gap-8">

                {/* SX: Pannello */}
                <AdminPanel />

                {/* DX: Card attività */}
                <div className="w-full max-w-[1000px] lg:min-w-[1000px]">
                    <AdminActivityFilter />

                    {/* Ricerca e aggiungi */}
                    <div className="flex flex-col md:flex-row w-full justify-between items-center mb-8 md:mb-0">
                        <ActivitiesNameSearch searchInput={searchInput} handleSearchInput={handleSearchInput} />
                        <GreenButton text="Aggiungi attività" link="/add-edit-activity" isFull />
                    </div>

                    {/* Counter */}
                    {
                        count &&
                        <div className="flex gap-2">
                            <div className="text-[#225424] font-bold">({count}</div>
                            <div>attività trovate.)</div>
                        </div>
                    }

                    <div className="flex flex-col gap-8 lg:gap-2 w-full">

                        {/* Cards */}
                        {
                            !isLoading && data && data.length > 0 && data.map((element, index) => {
                                if (searchInput) {
                                    if (element.title.toLowerCase().includes(searchInput.trim().toLowerCase())) {
                                        return <AdminCard key={index} elementData={element} type="Activity" />
                                    }
                                } else {
                                    return <AdminCard key={index} elementData={element} type="Activity" />
                                }
                            })
                        }
                        {
                            isLoading && <Loader isMobileCenter />
                        }
                        {
                            error && <Error message={error.message} />
                        }
                    </div>
                </div>
            </div>



        </PageContainer>
    )
}

export default HandleActivities;